import React from 'react'
function s2017() {
  return (
    <div>
        <h4>PClassic 2017 Spring Summary</h4>
<p>
PClassic happened this spring, on April 29th, 2017. We had  around 200 students on 70 teams from 30 schools making this the largest spring contest to date! </p>
<br />
This year's question set is <a href="/files/problems/PClassic2017sQuestions.pdf">online</a> and the test cases and solutions are available as a zip file.
<br />

    </div>
  )
}

export default s2017